/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import Box, { BoxProps } from '../Box/Box';
import { SxProp } from '../style/sxProp';
import useTheme from '../style/useTheme';

const ScreenContainer = <T extends keyof JSX.IntrinsicElements>({
  sx,
  as = 'div' as T,
  children,
  ...boxProps
}: BoxProps<T>): React.ReactElement => {
  const { isDarkMode, theme, useThemeNext } = useTheme();
  const themeSx = useMemo(
    () =>
      useThemeNext
        ? theme.components.background.default.sx?.next
        : theme.components.background.default.sx?.legacy,
    [theme, useThemeNext]
  );

  const boxSx = useMemo<SxProp>(
    () => ({
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      flex: 1,
      colorScheme: isDarkMode ? 'dark' : 'light',
      backgroundColor: {
        type: 'component',
        value: theme.components.background.default.color,
      },
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
        {
          width: '432px',
        },
      ...(themeSx as any),
      ...(sx as any),
    }),
    [sx, themeSx, isDarkMode, theme.components.background.default]
  );

  return (
    <Box as={as} sx={boxSx} {...boxProps}>
      {children}
    </Box>
  );
};

export default ScreenContainer;
